// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-emoji-picker {
  position: relative;
  z-index: 999999;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 300px;
  max-height: 350px;
  overflow: hidden;
}

.emoji-picker-header {
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.emoji-search {
  width: 100%;
  padding: 8px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
}

.emoji-search:focus {
  border-color: #1890ff;
}

.emoji-categories {
  display: flex;
  padding: 8px 10px;
  border-bottom: 1px solid #e0e0e0;
  gap: 2px;
  background-color: #f7f7f7;
}

.emoji-category-btn {
  flex: 1 1;
  padding: 6px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  border-bottom: 3px solid transparent;
}

.emoji-category-btn:hover {
  background-color: #e0e0e0;
}

.emoji-category-btn.active {
  background-color: #e6f4ff;
  border-bottom-color: #1890ff;
}

.emoji-picker-body {
  padding: 10px;
  max-height: 280px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.emoji-item {
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.emoji-item:hover {
  background-color: #f0f0f0;
  transform: scale(1.1);
}

.emoji-item img {
  display: block;
}

.emoji-item span {
  font-size: 24px;
  line-height: 1;
}

.emoji-no-results {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./src/components/Editor/emojiPicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB","sourcesContent":[".custom-emoji-picker {\n  position: relative;\n  z-index: 999999;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  width: 300px;\n  max-height: 350px;\n  overflow: hidden;\n}\n\n.emoji-picker-header {\n  padding: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.emoji-search {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  font-size: 14px;\n  outline: none;\n}\n\n.emoji-search:focus {\n  border-color: #1890ff;\n}\n\n.emoji-categories {\n  display: flex;\n  padding: 8px 10px;\n  border-bottom: 1px solid #e0e0e0;\n  gap: 2px;\n  background-color: #f7f7f7;\n}\n\n.emoji-category-btn {\n  flex: 1;\n  padding: 6px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n  border-bottom: 3px solid transparent;\n}\n\n.emoji-category-btn:hover {\n  background-color: #e0e0e0;\n}\n\n.emoji-category-btn.active {\n  background-color: #e6f4ff;\n  border-bottom-color: #1890ff;\n}\n\n.emoji-picker-body {\n  padding: 10px;\n  max-height: 280px;\n  overflow-y: auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.emoji-item {\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.emoji-item:hover {\n  background-color: #f0f0f0;\n  transform: scale(1.1);\n}\n\n.emoji-item img {\n  display: block;\n}\n\n.emoji-item span {\n  font-size: 24px;\n  line-height: 1;\n}\n\n.emoji-no-results {\n  padding: 20px;\n  text-align: center;\n  color: #999;\n  font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
